if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input[type="search"]');
      this.resultsContainer = this.querySelector(
        '.js-results-container'
      );
      this.btnSubmit = this.querySelector('.js-btn-submit');
      this.btnClearText = this.querySelector('.js-btn-clear-text');
      this.errorMessageContainer = this.querySelector(
        '.js-message-error'
      );
      this.errorMessageText =
        this.errorMessageContainer.querySelector('[data-text]');
      this.timeout = null;
      this.isOpen = false;
      this.drawer = this.closest('.js-drawer');

      var searchDrawerContent = document.querySelector('.drawer__content--search');
      var searchSuggestions = document.querySelector('.search-drawer__suggestions');

      this.input.addEventListener('input', e => {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          const searchTerm = this.input.value.trim();

          if (searchTerm.length <= 0) {
            this.close();
            if(DeviceDetector.isMobile() || DeviceDetector.isTablet()) {
              searchDrawerContent.style.height = 'auto';
            }
            if(searchSuggestions) {
              searchSuggestions.style.display = 'block';
            }
            return;
          }

          this.isOpen = true;
          this.getSearchResults(searchTerm);
          if(DeviceDetector.isMobile() || DeviceDetector.isTablet()) {
            searchDrawerContent.style.height = '100%';
          }
          if(searchSuggestions) {
            searchSuggestions.style.display = 'none';
          }
        }, 300);
      });

      this.input.addEventListener('keydown', e => {
        const isEscape = e.key === 'Escape';

        if (!isEscape) {
          return;
        }

        if (!this.input.value) {
          if (this.drawer) {
            this.drawer.parentElement.parentElement.toggleDrawer();
          }

          return;
        }

        this.close();
      });

      this.btnClearText.addEventListener('click', e => {
        this.close();
        searchDrawerContent.style.height = 'auto';
        if(searchSuggestions) {
          searchSuggestions.style.display = 'block';
        }
      });
    }

    async getSearchResults(searchTerm) {
      const token = (this.requestId = (this.requestId || 0) + 1);
      try {
        const response = await fetch(
          `${Shopify.routes.root}search/suggest?q=${encodeURIComponent(searchTerm)}&resources[type]=product,page,article,collection,query&resources[limit]=8&section_id=predictive-search`
        );

        if (!this.isOpen || token !== this.requestId) {
          return;
        }

        if (!response.ok) {
          const error = new Error(response.status);

          throw error;
        }

        const text = await response.text();
        if (token !== this.requestId) {
          return;
        }
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector(
            '#shopify-section-predictive-search'
          ).innerHTML;

        this.resultsContainer.innerHTML = resultsMarkup;
        this.open();

        document.querySelector('quick-cart-drawer')?.initTriggers();

      } catch (error) {
        this.errorMessageText.textContent = error.message;
        this.errorMessageContainer.classList.remove('hidden');
      }

      if (searchTerm.length >= 3) {
        this.fetchContentResults(searchTerm, token);
      }
    }

    async fetchContentResults(searchTerm, token) {
      try {
        const res = await fetch(
          `${Shopify.routes.root}search?q=${encodeURIComponent(searchTerm)}&type=article,page&options[prefix]=last&section_id=predictive-search-content`
        );
        if (!res.ok || !this.isOpen || token !== this.requestId) return;
        const cText = await res.text();
        if (!this.isOpen || token !== this.requestId) return;

        const contentCol = new DOMParser()
          .parseFromString(cText, 'text/html')
          .querySelector('[data-predictive-content] .predictive-search__col');
        if (!contentCol) return;

        const resultsRoot = this.resultsContainer.querySelector('.predictive-search__results');
        if (!resultsRoot) return;

        const norm = (u) => (u || '').split('?')[0].replace(/\/$/, '');
        const seen = new Set(
          Array.from(resultsRoot.querySelectorAll('a[href]')).map(a => norm(a.getAttribute('href')))
        );
        const ul = contentCol.querySelector('ul');
        if (!ul) return;
        let kept = 0;
        Array.from(ul.querySelectorAll('[data-content-url]')).forEach(li => {
          const url = norm(li.getAttribute('data-content-url'));
          if (!url || seen.has(url)) { li.remove(); } else { seen.add(url); kept++; }
        });
        if (kept <= 0) return;

        const msg = resultsRoot.querySelector('.predictive-search__message');
        if (msg) msg.remove();

        const viewAllCol = Array.from(resultsRoot.querySelectorAll('.predictive-search__col'))
          .find(c => c.querySelector('button[type="submit"]'));
        if (viewAllCol) {
          resultsRoot.insertBefore(contentCol, viewAllCol);
        } else {
          resultsRoot.appendChild(contentCol);
        }
      } catch (e) {
      }
    }

    open() {
      this.classList.add('is-open');
      this.resultsContainer.classList.remove('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.btnSubmit.setAttribute('tabindex', '-1');
      this.btnClearText.removeAttribute('disabled');
    }

    close() {
      this.isOpen = false;
      this.classList.remove('is-open');
      this.resultsContainer.classList.add('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.input.value = '';
      this.input.focus();
      this.btnSubmit.removeAttribute('tabindex');
      this.btnClearText.setAttribute('disabled', true);
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}
